angular.module('uofa.agentsportal')

/**
 * Accordion (UI Bootstrap)
 * https://angular-ui.github.io/bootstrap/
 */
.controller('AccordionCtrl', function ($scope) {
  $scope.oneAtATime = false;
});

function AccordionApplicationsLoadingCtrl($scope, $http, $timeout) {

// This LoadingController is attached to the DOM inside the ng-repeat
// so it has access to the "group" object, which is provided by the ng-repeat
    // We are going to watch the current scope for changes to group.anyOldValue
    $scope.$watch(

      // This is the expression (on $scope) to watch
      'accordion.isOpen',

      // This is the handler function that will be run "only" when the watched expression changes
      function(value) {
        // This first parameter is the changed value of group.anyOldValue
        // A second parameter would hold the previous value if you wanted it
        if ( value && ! $scope.isLoaded ) {
          $http.get(window.angular_datasources.config.app.url + '/api/v1/applicants/' + $scope.$parent.applicant.personal_id, {
              ignoreLoadingBar: true
          }).success(function(data) {
              $scope.applications = data[0].applications;
              $scope.isLoaded = true;
          });
        }
      }

    );
}
